<template>
    <div class="filter-min-max">
        <div class="filter-label" @click="showOptions = !showOptions">
            <div v-if="!filterProduct && !filterCategory && !filterBrand">{{ t('segments-filters-inform_values') }}</div>
            <div v-if="filterProduct">{{ t('product') }}: {{ filterProduct }}</div>
            <div v-if="filterCategory">{{ t('category') }}: {{ filterCategory }}</div>
            <div v-if="filterBrand">{{ t('brand') }}: {{ filterBrand }}</div>
            <div v-is="valueLabel" class="period-label">{{ valueLabel }}</div>
            <span v-if="periodLabel" class="period-label">
                {{ t('segments-filters-period_label', { period: periodLabel }) }}
            </span>
        </div>
        <div class="filter-options" v-if="showOptions" v-click-outside="clickedOutsideOptions">
            <div class="fields">
                <div class="field">
                    <label class="checkbox">{{ t('segments-filters-search_combined_info') }}</label>
                </div>
                <div class="field column">
                    <div>
                        <label class="label">{{ t('segments-filters-which_product') }} </label>
                    </div>
                    <div>
                        <input type="text" class="form-control" v-model="filterProduct">
                    </div>
                </div>

                <div class="field column">
                    <div>
                        <label class="label">{{ t('segments-filters-which_category') }} </label>
                    </div>
                    <div>
                        <input type="text" class="form-control" v-model="filterCategory">
                    </div>
                </div>

                <div class="field column">
                    <div>
                        <label class="label">{{ t('segments-filters-which_brand') }} </label>
                    </div>
                    <div>
                        <input type="text" class="form-control" v-model="filterBrand">
                    </div>
                </div>

                <div class="field">
                    <label class="checkbox">{{ t('segments-filters-purchase_quantity') }}</label>
                </div>
                <div class="field">
                    <label>{{ t('reportFilters-min') }}:</label>
                    <input type="tel" v-model="min" v-mask="options.mask" />
                </div>
                <div class="field">
                    <label>{{ t('reportFilters-max') }}:</label>
                    <input type="tel" v-model="max" v-mask="options.mask" />
                </div>

                <div class="field">
                    <label class="checkbox"><input type="checkbox" v-model="restrictPeriod" />{{ t('segments-filters-limit_time_range') }}</label>
                </div>

                <template v-if="restrictPeriod">
                    <div class="field">
                        <div class="period-title">{{ t('segments-filters-days_ago') }}</div>
                    </div>
                    <div class="field">
                        <label>{{ t('reportFilters-min') }}:</label>
                        <input type="tel" v-model="period.min" />
                    </div>
                    <div class="field">
                        <label>{{ t('reportFilters-max') }}:</label>
                        <input type="tel" v-model="period.max" />
                    </div>
                </template>
            </div>
            <div class="filter-actions">
                <button type="button" class="cancelBtn btn btn-sm btn-default" @click="cancel">
                    {{ t('segments-filters-close') }}
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.field {
    display: flex;

    &.column {
        flex-direction: column;
        padding: 0 10px;

        label {
            margin-left: 0;
            padding-left: 0;
        }
    }

    label {
        width: auto;
        display: block;
        margin-right: 10px;
    }
}

.period-label {
    display: block;
    font-size: 9px;
}

.filter-actions {
    margin-top: 20px;
}

label.checkbox {
    font-size: 10px;

    input {
        margin-right: 5px;
    }
}

.period-title {
    font-size: 12px;
    font-weight: 600;
    margin: 10px 0 0 10px;
}

input:not([type="checkbox"]) {
    border: none;
    border-bottom: 1px solid #ddd;
    box-shadow: none;
    font-size: 13px;
    flex-grow: 1;
    width: 100%;

    &:focus {
        outline: none;
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #ddd;
    }
}
</style>
<script>
import keviApi from "../../keviApi";

export default {
    name: "purchased-product",
    props: {
        currentValue: {
            type: Object,
            default: () => ({
                min: null,
                max: null,
                product: "",
                category: "",
                brand: "",
                restrictPeriod: false,
                period: {
                    min: null,
                    max: null,
                },
            }),
        },
        options: {
            type: Object,
            default: () => ({
                mask: "R$ ######,##",
                optionsWidth: 300,
            }),
        },
        name: {
            type: String,
            default: "product",
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => { },
            value: "",
            changedValue: false,
            min: null,
            max: null,
            period: {
                min: null,
                max: null,
            },
            filterProduct: "",
            filterCategory: "",
            filterBrand: "",
            restrictAmountOfPurchases: false,
            restrictPeriod: false,
            loading: false,
        };
    },
    mounted() {
        if (this.currentValue) {
            let value = this.currentValue;
            this.max = value.max;
            this.min = value.min;
            this.restrictPeriod = value.restrictPeriod;
            this.period.min = value.period.min;
            this.period.max = value.period.max;
            this.filterProduct = value.product;
            this.filterCategory = value.category;
            this.filterBrand = value.brand;
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        cancel() {
            this.showOptions = false;
        },
        changed() {
            this.$emit("changed", this.value);
        },
        checkValuesOrder() {
            if (this.max && this.maxFloat < this.minFloat) {
                let max = this.max;
                let min = this.min;
                this.max = min;
                this.min = max;
            }

            if (
                this.period.max &&
                this.getFloat(this.period.max) < this.getFloat(this.period.min)
            ) {
                let periodMax = this.period.max;
                let periodMin = this.period.min;
                this.period.max = periodMin;
                this.period.min = periodMax;
            }
        },
        setValue() {
            this.checkValuesOrder();
            this.value = {
                min: this.minFloat,
                max: this.maxFloat,
                product: this.filterProduct,
                category: this.filterCategory,
                brand: this.filterBrand,
                restrictPeriod: this.restrictPeriod ? 1 : "",
                period: {
                    min: this.getFloat(this.period.min),
                    max: this.getFloat(this.period.max),
                },
            };
        },
        getFloat(n) {
            if (n === null) {
                return null;
            }
            return parseFloat(
                String(n)
                    .replace(/[^0-9,]/gi, "")
                    .replace(",", "."),
            );
        },
    },
    computed: {
        maxFloat() {
            return this.getFloat(this.max);
        },
        minFloat() {
            return this.getFloat(this.min);
        },
        valueLabel() {
            if ((!this.min && !this.max) || !this.filterProduct) {
                return "";
            } else if (!this.min && this.max) {
                return this.t('segments-filters-until') + " " + this.max + " " + this.t('segments-filters-purchases');
            } else if (!this.max && this.min) {
                return this.t('segments-filters-from') + " " + this.min + " " + this.t('segments-filters-purchases');
            } else {
                return this.t('segments-filters-between') + " " + this.min + " " + this.t('segments-filters-and') + " " + this.max + " " + this.t('segments-filters-purchases');
            }
        },
        periodLabel() {
            if (!this.restrictPeriod) {
                return "";
            }
            if (!this.period.min && !this.period.max) {
                return "";
            } else if (!this.period.min && this.period.max) {
                return this.t('segments-filters-until') + " " + this.period.max;
            } else if (!this.period.max && this.period.min) {
                return this.t('segments-filters-more_than') + " " + this.period.min;
            } else {
                return this.t('segments-filters-between') + " " + this.period.min + " " + this.t('segments-filters-and') + " " + this.period.max;
            }
        },
    },
    watch: {
        showOptions() {
            this.setValue();
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => { };
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
